/* global axios */

import ApiClient from './ApiClient';

class ZakiAgentSetting extends ApiClient {
  constructor() {
    super('zaki_agent_setting', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(payload) {
    return axios.patch(this.url, payload);
  }
}

export default new ZakiAgentSetting();
